// extracted by mini-css-extract-plugin
export default {"editor":"FormMarkdownEditor-module_editor__yTsGKU"};